<template>
  <div class="platformReportRecord">
    <div class="header">
      <span class="el-icon-circle-check header_icon"></span>
      <span class="header_text">数据正常上报中</span>
    </div>
    <div class="table_panel">
      <el-table
        :data="list"
        stripe
        border>
        <el-table-column prop="interfaceTypeName" label="上报内容" min-width="160"></el-table-column>
        <el-table-column prop="previousUploadTime" label="最近一次上报时间" min-width="240"></el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
  import req from '@/utils/request'
  export default {
    name: 'platformReportRecord',
    data() {
      return {
        list: []
      }
    },
    created () {
      this.getList()
    },
    methods: {
      async getList () {
        const res = await req.get(`/system/clinic/wjw-upload-info/${sessionStorage.getItem('deptId')}`)
        if (res.code === 200) {
          this.list = res.data
        }
      }
    }
  }
</script>

<style lang="less" scoped>
  .platformReportRecord {
    width: 100%;
    height: 100%;
  }

  .header {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
  }

  .header_icon {
    font-size: 28px;
    color: #67C23A;
  }

  .header_text {
    margin: 0 0 0 4px;
    font-weight: 600;
    font-size: 20px;
    color: #333333;
  }

  .table_panel {
    margin: 16px 0 0 0;
    width: 600px;
  }
</style>